import { instance2 } from "App/constants";
import React from "react";
import {
  defaultDateDisplay,
  defaultToastError,
  defaultToastSuccess,
} from "App/utils/helpers";

export const RESET_STATE_MENU = {
  id: "",
  code: "",
  name: "",
  parent_code: "",
  is_root: 0,
  is_function: 0,
  seq: "",
  status: 1,

  add_on_parent: 1,
  edit: 0,
  add_on_child: 0,
  is_root_func: "3",

  is_root_parent: 0,
  is_func_parent: 0,

  remark: "Menu ini digunakan untuk admin",
};

export const getAllListMenu = async () => {
  try {
    const api = await instance2.get("/menumanagement/listmenu_full");
    const res = api?.data.body;
    return res;
  } catch (error) {
    return false;
  }
};

export const deleteMenuById = async (
  id,
  run,
  setShowModalDeleteConfirm,
  setFormData
) => {
  try {
    await instance2.post(
      "/menumanagement/deletemenu",
      {},
      {
        headers: {
          idmenu: id,
        },
      }
    );
    run(!run);
    setShowModalDeleteConfirm(false);
    setFormData(RESET_STATE_MENU);
    return defaultToastSuccess("Data berhasil dihapus");
  } catch (error) {
    return defaultToastError(error?.response?.data?.message);
  }
};

export const headCells = [
  {
    id: "no",
    disablePadding: false,
    label: "NO",
    align: "center",
    sort: false,
  },
  {
    id: "act",
    disablePadding: true,
    label: "ACT",
    sort: false,
    align: "left",
    minWidth: "200px",
  },
  {
    id: "code",
    disablePadding: false,
    label: "KODE",
    sort: false,
    minWidth: "100px",
  },
  {
    id: "name",
    disablePadding: false,
    label: "NAMA",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "is_root",
    disablePadding: false,
    label: "IS ROOT",
    sort: false,
    minWidth: "100px",
  },

  {
    id: "is_function",
    disablePadding: false,
    label: "IS FUNC",
    sort: false,
    minWidth: "100px",
  },

  {
    id: "inserted_time",
    disablePadding: false,
    label: "INSERTED TIME",
    sort: false,
    minWidth: "170px",
  },
  {
    id: "inserted_by",
    disablePadding: false,
    label: "INSERTED BY",
    sort: false,
    minWidth: "150px",
  },
  {
    id: "updated_time",
    disablePadding: false,
    label: "UPDATED TIME",
    sort: false,
    minWidth: "170px",
  },
  {
    id: "updated_by",
    disablePadding: false,
    label: "UPDATED BY",
    sort: false,
    minWidth: "150px",
  },
];

export const TableCellMenu = ({ row }) => {
  return (
    <>
      <td align='left'>{defaultDateDisplay(row?.ceratedAt)}</td>
      <td align='left'>{row?.createdName}</td>
      <td align='left'>{defaultDateDisplay(row?.updatedAt)}</td>
      <td align='left'>{row?.updatedName}</td>
    </>
  );
};

export const RenderArrow = ({ row, margin }) => {
  if (row.sub.length > 0) {
    return (
      <div
        className='wrap-icon'
        style={{
          marginLeft: `${margin}px`,
        }}>
        <span className='arrow'>
          <ArrowDown />
        </span>
        {row.code}
      </div>
    );
  } else {
    return (
      <div
        className='wrap-icon'
        style={{
          marginLeft: `${margin + 30}px`,
        }}>
        {row.code}
      </div>
    );
  }
};

export const ArrowDown = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      height='20px'
      className='h-5 w-5'
      viewBox='0 0 20 20'
      fill='#00000'>
      <path
        fillRule='evenodd'
        d='M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z'
        clipRule='evenodd'
      />
    </svg>
  );
};

export const setVal = (row, setFormData) => {
  setFormData({
    id: row.id,
    code: row.code,
    is_function: row.is_function,
    is_root: row.is_root,
    name: row.name,
    icon: row.icon,
    parent_code: row.parent_code,
    seq: row.seq,
    status: row.status,
    remark: row.remark,

    add_on_parent: 0,
    edit: 1,
    add_on_child: 0,
  });
};

export const clickDelete = (row, setFormData) => {
  setFormData({
    id: row?.id,
  });
};
